import type { ToastDescriptionProps } from './types'

import { Toast as BaseToast } from '@base-ui/react/toast'

import { textVariants } from '#components/text/styles'
import { TextColor, TextSize, TextWeight } from '#components/text/types'
import { cn } from '#lib/cn'

export function ToastDescription({
  className,
  ...props
}: ToastDescriptionProps) {
  return (
    <BaseToast.Description
      className={cn(
        'm-0',
        textVariants({
          size: TextSize.Medium,
          weight: TextWeight.Regular,
          color: TextColor.Inherit,
        }),
        className,
      )}
      {...props}
    />
  )
}
ToastDescription.displayName = 'Toast.Description'
